import translations from './translations'

translations.add('pt', {
    lookUp: 'Procurar os meus cartões'
})
